module.exports = __webpack_public_path__ + "img/fineness-1@2x.ba3e2d4.webp";